import type { ErrorInfo } from 'react';
import type React from 'react';
import { Component } from 'react';
import { GeneralError } from './components/pages/GeneralError';
import { telemetry } from './telemetry';

interface Props {
  children: React.ReactNode;
  fallback?: React.ComponentType<{ error?: Error; retry?: () => void }>;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error to telemetry
    telemetry.captureError(error, { errorInfo });

    // Set state with error details
    this.setState({
      hasError: true,
      error,
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (this.state.hasError) {
      // Use custom fallback if provided, otherwise use default GeneralError
      const FallbackComponent = this.props.fallback || GeneralError;
      return <FallbackComponent error={this.state.error} retry={this.handleRetry} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
